export default {
  SET_LIST_DATA: "documents/SET_LIST_DATA",
  SET_LOADING_STATE: "documents/SET_LOADING_STATE",
  SET_DIALOG_STATE: "documents/SET_DIALOG_STATE",
  SET_REJECT_REASON_STATE: "documents/SET_REJECT_REASON_STATE",
  SET_SELECTED_DOCUMENT_STATE: "documents/SET_SELECTED_DOCUMENT_STATE",
};
